// src/components/AccessCodeModal.js

import React, { useState, useEffect, useContext } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
} from '@mui/material';
import { AuthContext } from '../context/AuthContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AccessCodeModal = ({ open, onClose }) => {
  const { user, jwtToken, guilds } = useContext(AuthContext);
  const [code, setCode] = useState('');
  const [selectedGuildId, setSelectedGuildId] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!code || !selectedGuildId) {
      setError('Please enter a code and select a guild.');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/redeem-code`,
        {
          code,
          guildId: selectedGuildId,
        },
        {
          headers: { Authorization: `Bearer ${jwtToken}` },
        }
      );

      alert('Code redeemed successfully! Subscription activated.');

      navigate('/setup');

      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Enter Access Code</DialogTitle>
      <DialogContent>
        <TextField
          label="Access Code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          fullWidth
          margin="normal"
        />
        <FormControl fullWidth margin="normal">
          <InputLabel id="guild-select-label">Select Guild</InputLabel>
          <Select
            labelId="guild-select-label"
            value={selectedGuildId}
            onChange={(e) => setSelectedGuildId(e.target.value)}
          >
            {guilds.map((guild) => (
              <MenuItem key={guild.id} value={guild.id}>
                {guild.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} disabled={isSubmitting}>
          {isSubmitting ? <CircularProgress size={24} /> : 'Redeem Code'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccessCodeModal;

